const newMenuItems = [
  {
    id: 1,
    title: "news",
    newsData: [
      {
        id: 1,
        text: "Home",
        path: "/",
      },

      {
        id: 2,
        text: "International",
        path: "/international",
      },
      {
        id: 3,
        text: "Bangladesh",
        path: "/bangladesh",
      },
      {
        id: 4,
        text: "Business",
        path: "/business",
      },
      {
        id: 5,
        text: "Entertainment",
        path: "/entertainment",
      },
      {
        id: 6,
        text: "environment",
        path: "/environment",
      },
      {
        id: 7,
        text: "Sports",
        path: "/sports",
      },
      {
        id: 8,
        text: "Tech",
        path: "/tech",
      },

      {
        id: 9,
        text: "Politics",
        path: "/bangladesh/politics",
      },

      {
        id: 10,
        text: "Global Business",
        path: "/business/globalbusiness",
      },
    ],
  },
  {
    id: 2,
    title: "opinion",
    newsData: [
      {
        id: 1,
        text: "Bangladesh",
        path: "/comingSoon",
      },

      {
        id: 2,
        text: "India",
        path: "/comingSoon",
      },
      {
        id: 3,
        text: "United Kingdom",
        path: "/comingSoon",
      },
      {
        id: 4,
        text: "Australia",
        path: "/comingSoon",
      },
      {
        id: 5,
        text: "Europe",
        path: "/comingSoon",
      },
      {
        id: 6,
        text: "Japan",
        path: "/comingSoon",
      },
    ],
  },
  {
    id: 3,
    title: "arts",
    newsData: [
      {
        id: 1,
        text: "Television",
        path: "/entertainment/television",
      },

      {
        id: 2,
        text: "Movie",
        path: "/entertainment/movies",
      },
      {
        id: 3,
        text: "Music",
        path: "/entertainment/music",
      },
    ],
  },
  {
    id: 4,
    title: "living",
    newsData: [
      {
        id: 1,
        text: "News",
        path: "/liveNews",
      },

      {
        id: 2,
        text: "Videos",
        path: "/videos",
      },
    ],
  },
  {
    id: 5,
    title: "more",
    newsData: [
      {
        id: 1,
        text: "Weather",
        path: "/weather",
      },
    ],
  },
];

export default newMenuItems;
